// NOTE: The values are defined in vue.config.js
declare const PIPING_SERVER_URLS: ReadonlyArray<string>;

const c = {
  pipingServerUrls: PIPING_SERVER_URLS,
};

export default c;
